import { Header } from '../components/Header';
import { PageIntro } from '../components/PageIntro';
import { ContactSection } from '../components/ContactSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
export function ContactPage() {
  return (
    <>
      <Header />
      <PageIntro
        eyebrow="Контакты"
        title="Обсудим вашу задачу"
        description="Начнём с объектов, объёма работ и сроков. Подготовим предложение под ваш проект."
      />
      <ContactSection />
      <FAQSection />
      <Footer />
    </>
  );
}
